/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SubscribePlanChangeUpgradeGet200Response } from '../models';
/**
 * PlanChangeApi - axios parameter creator
 * @export
 */
export const PlanChangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 플랜 업그레이드 정보 조회
         * @param {string} orderId 
         * @param {string} [fromPlan] 
         * @param {string} [toPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribePlanChangeUpgradeGet: async (orderId: string, fromPlan?: string, toPlan?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('subscribePlanChangeUpgradeGet', 'orderId', orderId)
            const localVarPath = `/api/v1/subscribe/plan-change/upgrade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (fromPlan !== undefined) {
                localVarQueryParameter['fromPlan'] = fromPlan;
            }

            if (toPlan !== undefined) {
                localVarQueryParameter['toPlan'] = toPlan;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanChangeApi - functional programming interface
 * @export
 */
export const PlanChangeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanChangeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 플랜 업그레이드 정보 조회
         * @param {string} orderId 
         * @param {string} [fromPlan] 
         * @param {string} [toPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribePlanChangeUpgradeGet(orderId: string, fromPlan?: string, toPlan?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscribePlanChangeUpgradeGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribePlanChangeUpgradeGet(orderId, fromPlan, toPlan, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanChangeApi.subscribePlanChangeUpgradeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanChangeApi - factory interface
 * @export
 */
export const PlanChangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanChangeApiFp(configuration)
    return {
        /**
         * 
         * @summary 플랜 업그레이드 정보 조회
         * @param {PlanChangeApiSubscribePlanChangeUpgradeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribePlanChangeUpgradeGet(requestParameters: PlanChangeApiSubscribePlanChangeUpgradeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscribePlanChangeUpgradeGet200Response> {
            return localVarFp.subscribePlanChangeUpgradeGet(requestParameters.orderId, requestParameters.fromPlan, requestParameters.toPlan, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanChangeApi - interface
 * @export
 * @interface PlanChangeApi
 */
export interface PlanChangeApiInterface {
    /**
     * 
     * @summary 플랜 업그레이드 정보 조회
     * @param {PlanChangeApiSubscribePlanChangeUpgradeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanChangeApiInterface
     */
    subscribePlanChangeUpgradeGet(requestParameters: PlanChangeApiSubscribePlanChangeUpgradeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscribePlanChangeUpgradeGet200Response>;

}

/**
 * Request parameters for subscribePlanChangeUpgradeGet operation in PlanChangeApi.
 * @export
 * @interface PlanChangeApiSubscribePlanChangeUpgradeGetRequest
 */
export interface PlanChangeApiSubscribePlanChangeUpgradeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PlanChangeApiSubscribePlanChangeUpgradeGet
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof PlanChangeApiSubscribePlanChangeUpgradeGet
     */
    readonly fromPlan?: string

    /**
     * 
     * @type {string}
     * @memberof PlanChangeApiSubscribePlanChangeUpgradeGet
     */
    readonly toPlan?: string
}

/**
 * PlanChangeApi - object-oriented interface
 * @export
 * @class PlanChangeApi
 * @extends {BaseAPI}
 */
export class PlanChangeApi extends BaseAPI implements PlanChangeApiInterface {
    /**
     * 
     * @summary 플랜 업그레이드 정보 조회
     * @param {PlanChangeApiSubscribePlanChangeUpgradeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanChangeApi
     */
    public subscribePlanChangeUpgradeGet(requestParameters: PlanChangeApiSubscribePlanChangeUpgradeGetRequest, options?: RawAxiosRequestConfig) {
        return PlanChangeApiFp(this.configuration).subscribePlanChangeUpgradeGet(requestParameters.orderId, requestParameters.fromPlan, requestParameters.toPlan, options).then((request) => request(this.axios, this.basePath));
    }
}

